// extracted by mini-css-extract-plugin
export default {"bodyPlaceholder":"BodyPlaceholder_bodyPlaceholder__M3r47","error":"BodyPlaceholder_error__JeXV0","fillParent":"BodyPlaceholder_fillParent__HY1+C"};